// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24KQX","clinicsSelect":"styles_clinicsSelect__2K64S"};